import React, { Component } from 'react';
import voca from 'voca';
import CopyToClipboard from 'react-copy-to-clipboard';
import { filterFieldsForPlaceholderModal } from 'drapcode-constant';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Accordion } from 'react-accessible-accordion';
import { drapcodeIcon } from '../custom/icon-library';
import { createFieldKey } from '../utils/builder-url-util';
import { extractRefField } from '../utils/field-options';
import { CustomAccordion } from './CustomAccordion';

export default class PlaceholderFieldsModal extends Component {
  getFieldRows = (fieldName, fieldTitle) => {
    const clipboardStyle = {
      cursor: 'pointer',
      padding: '4px',
      verticalAlign: 'middle',
      margin: 0,
    };
    return (
      <tr key={fieldName} className="text-left td-align-middle">
        <td title={fieldTitle}>{voca.truncate(fieldTitle, 30)}</td>
        <td title={fieldTitle}>
          <>
            <CopyToClipboard
              text={createFieldKey(`${fieldName}`)}
              onCopy={this.props.copyToClipboard}
              title={'Copy to clipboard'}
              style={clipboardStyle}
            >
              <span>
                {voca.truncate(`${fieldName}`, 35)}
                <i className="webconnect webconnect-files" />
              </span>
            </CopyToClipboard>
            <span className="float-right">
              {this.props.insertTextToEditor && (
                <>
                  <span
                    style={clipboardStyle}
                    title="Add field"
                    className="btn badge badge-theme"
                    onClick={() => this.props.insertTextToEditor(createFieldKey(`${fieldName}`))}
                  >
                    <i className="material-icons">add_box</i>
                  </span>
                </>
              )}
            </span>
          </>
        </td>
      </tr>
    );
  };

  placeholderFieldRows = (category) => {
    const { fields } = category || '';
    return (
      fields &&
      fields.map((field) => {
        return this.getFieldRows(field.name, field.title);
      })
    );
  };

  getFieldName = (name, prefix) => {
    return prefix ? `${prefix}${name}` : name;
  };

  collectionAllowedField = (fields) => {
    if (!fields || fields.length === 0) return '';
    const fieldsToShow = filterFieldsForPlaceholderModal(fields);
    const fieldObjArr = [];
    fieldsToShow.forEach((field) => {
      fieldObjArr.push({ title: field.fieldTitle.en, name: field.fieldName });
    });
    return fieldObjArr;
  };

  collectionFieldRows = (collection, prefix = '') => {
    let notFoundStr = '';
    if (!collection) {
      notFoundStr = 'Collection not found.';
    } else if (!collection.fields || collection.fields.length === 0) notFoundStr = 'No fields.';
    if (notFoundStr) {
      return (
        <tr className="text-left td-align-middle">
          <td colSpan={2}>{notFoundStr}</td>
        </tr>
      );
    }

    return this.collectionAllowedField(collection.fields).map((fieldObj) =>
      this.getFieldRows(`${prefix}${fieldObj.name}`, fieldObj.title),
    );
  };

  collectionRefFieldRows = (collection, prefix = 'RF::') => {
    const { collections } = this.props;
    let notFoundStr = '';
    if (!collection) {
      notFoundStr = 'Collection not found.';
    } else if (!collection.fields || collection.fields.length === 0) notFoundStr = 'No fields.';
    if (notFoundStr) {
      return (
        <tr className="text-left td-align-middle">
          <td colSpan={2}>{notFoundStr}</td>
        </tr>
      );
    }

    return extractRefField(collection.fields, collections).map((fieldObj) =>
      this.getFieldRows(`${prefix}${fieldObj.fieldName}`, fieldObj.fieldTitle),
    );
  };

  sessionRow = () => {
    return (
      <>
        {/* {this.getFieldRows('current_session.REPLACE_ME_WITH_KEY', 'Browser Session')}
        {this.getFieldRows('form_data_session.REPLACE_ME_WITH_KEY', 'Browser Session Form Data')} */}
        {this.getFieldRows(
          'SESSION_STORAGE.<replace_with_key_full_path>',
          'Browser Session Storage',
        )}
        {this.getFieldRows('LOCAL_STORAGE.<replace_with_key_full_path>', 'Browser Local Storage')}
        {this.getFieldRows('COOKIES.<replace_with_key_full_path>', 'Browser Cookies')}
        {this.getFieldRows('INDEXED_DB.<replace_with_key_full_path>', 'Browser IndexedDB')}
      </>
    );
  };

  render() {
    const { fieldsData, collections } = this.props;
    const { defaultCategory, categories } = fieldsData || '';
    const userCollection =
      collections &&
      collections.find((collection) => {
        return collection.collectionName === 'user';
      });

    return (
      <>
        <Modal
          isOpen={this.props.toggleFields}
          toggle={() => this.props.toggleFieldsModal()}
          backdrop="static"
          style={{ maxWidth: '800px', marginTop: '70px' }}
        >
          <ModalHeader toggle={() => this.props.toggleFieldsModal()} className="border-bottom">
            <strong>Fields</strong>
          </ModalHeader>
          <ModalBody>
            <Accordion allowZeroExpanded preExpanded={[defaultCategory || '']}>
              {categories &&
                categories.map((category) => (
                  <CustomAccordion
                    id={category.name}
                    tittle={category.title}
                    icon={`wb ${drapcodeIcon(category.icon || 'fields')}`}
                  >
                    {this.placeholderFieldRows(category)}
                  </CustomAccordion>
                ))}
            </Accordion>
            <Accordion allowZeroExpanded preExpanded={[defaultCategory || '']}>
              <CustomAccordion
                id={'user-fields'}
                tittle={'Current LoggedIn User Fields'}
                icon={`wb webconnect-card-list`}
              >
                {userCollection && this.collectionFieldRows(userCollection, 'current_user.')}
                {userCollection && this.collectionRefFieldRows(userCollection, 'current_user.')}
              </CustomAccordion>
            </Accordion>
            <Accordion allowZeroExpanded preExpanded={[defaultCategory || '']}>
              <CustomAccordion
                id={'current-session'}
                tittle={'Browser Session'}
                icon={`wb webconnect-form`}
              >
                {this.sessionRow()}
              </CustomAccordion>
            </Accordion>
          </ModalBody>
        </Modal>
      </>
    );
  }
}
